module.exports = __webpack_public_path__ + "img/startercp2023_230630.01aff40e.jpg";